// extracted by mini-css-extract-plugin
export default {"wrapper":"Gz-z","viewport":"Hz-z","container":"Iz-z","slide":"Jz-z"};